import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Box, CircularProgress, Typography } from '@mui/material';

const AdminRoute = ({ children }) => {
    const { user, isAdmin, userRole, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    // Guest users are blocked from this route even if they have the admin claim
    if (user && isAdmin && userRole !== 'Guest') {
        return children;
    }

    if (user) {
        return <Navigate to="/contacts" replace />;
    }

    return <Navigate to="/login" state={{ from: location }} replace />;
};

export default AdminRoute;
